module.exports = new __parcel__URL__("save_and_exit_button.ccff2424.png").toString();